// For selecting a parent relationship from a feedback

import React from "react";
import { SelectDropdown } from "@cadmakers-ui/core";
import { RelationshipDisplayFeedback } from "../../../Models/Feedback";

type ParentFeedbackValue = {
  value: number;
  label: string;
};

type Props = {
  options: RelationshipDisplayFeedback[];
  value?: ParentFeedbackValue;
  onSelect?: (
    parentId: number,
    parentTitle: string,
    prevParentId?: number,
    prevParentTitle?: string
  ) => void;
};

export const ParentFeedbackDropdown = (props: Props) => {
  const getOptions = () => {
    const options: ParentFeedbackValue[] = [{ value: -1, label: "No Parent Feedback" }];
    return options.concat(props.options);
  };

  const filterCaseInsensitive = (option: any, value: any) => {
    return option.label.toLowerCase().includes(value.toLowerCase());
  };

  const onChange = (newValue: any) => {
    if (props.onSelect) {
      props.onSelect(newValue.value, newValue.label, props.value?.value, props.value?.label);
    }
  };

  return (
    <SelectDropdown
      options={getOptions()}
      value={props.value}
      onChange={newValue => onChange(newValue)}
      customFilterOption={filterCaseInsensitive}
    />
  );
};
